import moment from 'moment';

export const isOverMaxAge = (birthDate) => {
  const LOGICAL_MAXIMUM_AGE = 100;
  const birthDateMoment = moment(birthDate, 'YYYY-MM-DD', true);
  const dateIsCorrectlyFormatted = birthDate === birthDateMoment.format('YYYY-MM-DD');
  let result = false;
  if (dateIsCorrectlyFormatted) {
    const differenceInYears = moment().diff(birthDateMoment, 'years');
    result = differenceInYears < LOGICAL_MAXIMUM_AGE;
  }
  return result;
};

export const isUnderMinAge = (birthDate) => {
  const MINIMUM_AGE = 18;
  const birthDateMoment = moment(birthDate, 'YYYY-MM-DD', true);
  const dateIsCorrectlyFormatted = birthDate === birthDateMoment.format('YYYY-MM-DD');
  let result = false;
  if (dateIsCorrectlyFormatted) {
    const differenceInYears = moment().diff(birthDateMoment, 'years');
    result = differenceInYears >= MINIMUM_AGE;
  }
  return result;
};
